import { render, staticRenderFns } from "./RetailProducts.vue?vue&type=template&id=7153e39f"
import script from "./RetailProducts.vue?vue&type=script&lang=js"
export * from "./RetailProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports